module.exports = __webpack_public_path__ + "img/impostor-music-listening.e37692c6.webp";